import { useEffect, useState } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useTickets = ({
  searchParam,
  tags,
  users,
  pageNumber,
  status,
  date,
  updatedAt,
  showAll,
  queueIds,
  withUnreadMessages,
  searchOnMessages,
  sortAscending, // ✅ AGREGADO: Para ordenamiento
  channel,
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    // Debounce alto sólo cuando hay texto de búsqueda (evita ráfagas al tipear).
    // Cambio de pestaña / filtros sin búsqueda: sin espera artificial (Fase C 0296).
    const debounceMs =
      typeof searchParam === "string" && searchParam.trim().length > 0 ? 280 : 0;

    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        try {
          // ✅ NO CONVERTIR STATUS "ai" - Enviar directamente al backend
          const backendStatus = status;
          
          const { data } = await api.get("/tickets", {
            params: {
              searchParam,
              pageNumber,
              tags,
              users,
              status: backendStatus,
              date,
              updatedAt,
              showAll: showAll ? "true" : "false", // ✅ CORREGIDO: Convertir boolean a string
              queueIds,
              withUnreadMessages,
              searchOnMessages,
              sortAscending, // ✅ AGREGADO: Parámetro de ordenamiento
              channel,
            },
          });
          setTickets(data.tickets);
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchTickets();
    }, debounceMs);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    tags,
    users,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    searchOnMessages,
    sortAscending, // ✅ AGREGADO: Dependencia para ordenamiento
    channel,
  ]);

  return { tickets, loading, hasMore };
};

export default useTickets;
